import React from 'react';
//import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
//import MainSlider from './pages/MainSlider';
import BookCategories from './pages/BookCategories';
import Footer from './pages/Footer';
import ContactUs from './pages/ContactUs';
import FooterInfo from './pages/FooterInfo';
//import BlogSection from './pages/BlogSection';
//import CustomerSection from './pages/CustomerSection';
//import AboutUs from './pages/AboutUs';
import { Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import HomePage from './pages/HomePage';
import BooksSearch from './pages/search/BooksSearch';
import MyProfile from './pages/profile/MyProfile';
import IssueBooks from './pages/admin/IssueBooks';
import ReturnBooks from './pages/admin/ReturnBooks';
import AddBooks from './pages/admin/AddBooks';
import HomeReports from './pages/reports/HomeReports';
import { ProductContext } from './ProductProvider';
import AboutUsMain from './pages/AboutUsMain';
import MyBooks from './pages/profile/MyBooks';
import BarcodePrint from './pages/barcode/BarcodePrint';
import BarcodeMainView from './pages/barcode/BarcodeMainView';
import IssueReturnView from './pages/admin/issuereturn/IssueReturnView';
import JournalForm from './pages/journal/JournalForm';
import JournalIssues from './pages/journal/JournalIssues';
import JournalManage from './pages/journal/JournalManage';
import JournalView from './pages/journal/JournalView';
import SearchMain from './pages/search/SearchMain';
import HelpGuide from './pages/help/HelpGuide';

function App() {
const { validateLogin, loginValidated } = React.useContext(ProductContext);

  React.useEffect(() => {
    //document.title = "VJ Library";
    console.log("App.js loaded");
    //console.log("Login Validated: ", loginValidated);
  }, []);

  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/search" element={<SearchMain />} />
        <Route path="/help" element={<HelpGuide />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/myprofile" element={<MyProfile />} />
        <Route path="/mybooks" element={<MyBooks />} />
        <Route path="/categories" element={<BookCategories />} />
        <Route path="/aboutus" element={<AboutUsMain />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/issuebooks" element={<IssueBooks />} />
        <Route path="/issuereturnbooks" element={<IssueReturnView />} />
        <Route path="/returnbooks" element={<ReturnBooks />} />
        <Route path="/managebooks" element={<AddBooks />} />
        <Route path="/reports" element={<HomeReports />} />
        <Route path="/journal/add" element={<JournalView />} />
        <Route path="/managejournal" element={<JournalManage />} />
        <Route path="/barcode" element={<BarcodeMainView/>} />
        <Route path="*" element={<Navigate to="/" replace />}/>
      </Routes>
      <FooterInfo />
      <Footer />
    </div>
  );
}

export default App;
